import {dataTestId} from '@hconnect/uikit'
import {Dialog, useMediaQuery, useTheme} from '@mui/material'
import React, {useMemo} from 'react'

import {DayPeriod, StrengthTarget} from '../types'

import {StrengthTargetFormContent} from './StrengthTargetFormContent'

interface StrengthTargetFormDialogProps {
  open: boolean
  target?: StrengthTarget
  defaultDayPeriod: DayPeriod
  timezone: string
  onClose: () => void
  onSave: (target: StrengthTarget) => void
  existingTargets: StrengthTarget[]
  backendTargets: StrengthTarget[]
}

export const StrengthTargetFormDialog: React.FC<StrengthTargetFormDialogProps> = ({
  open,
  target,
  defaultDayPeriod,
  timezone,
  onClose,
  onSave,
  existingTargets,
  backendTargets
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const formKey = useMemo(() => {
    if (!open) return 'closed'
    return target?.id ?? `new-${Date.now()}`
  }, [open, target?.id])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: {xs: 0, md: 2}
        }
      }}
      {...dataTestId('strength_target_form_dialog')}
    >
      {open && (
        <StrengthTargetFormContent
          key={formKey}
          target={target}
          defaultDayPeriod={defaultDayPeriod}
          timezone={timezone}
          onClose={onClose}
          onSave={onSave}
          existingTargets={existingTargets}
          backendTargets={backendTargets}
          isMobile={isMobile}
        />
      )}
    </Dialog>
  )
}
